module.exports = __webpack_public_path__ + "static/BackgroundPrint-c9f4866fb1aab11f58271270ded811ad.png";